import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiMusicGeneratorConfig } from '@/data/landingConfig/landingAiMusicGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiMusicGenerator } from './schemaObject';

interface Props {}
const AiMusicGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiMusicGenerator} />
			<LandingTemplate
				data={landingAiMusicGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelMusicGenerator()}
			/>
		</>
	);
};

export default AiMusicGenerator;
